import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslationModule } from '@core/translation/translation.module';
import { BerthOnlineBookingQrPanelComponent } from '../berth-online-booking-qr-panel/berth-online-booking-qr-panel.component';

export interface BerthOnlineBookingQrDialogData {
    berthId: number;
    berthHandle: string;
}

@Component({
    selector: 'berth-online-booking-qr-dialog',
    templateUrl: './berth-online-booking-qr-dialog.component.html',
    styleUrls: ['./berth-online-booking-qr-dialog.component.scss'],
    standalone: true,
    imports: [
        MatDialogModule,
        MatButtonModule,
        TranslationModule,
        BerthOnlineBookingQrPanelComponent,
    ],
})
export class BerthOnlineBookingQrDialogComponent {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: BerthOnlineBookingQrDialogData,
        private _dialogRef: MatDialogRef<BerthOnlineBookingQrDialogComponent>,
    ) {
    }

    close(): void {
        this._dialogRef.close();
    }
}
